// Import dependencies
import styled from 'styled-components';

// Import css
import '../../App.css'

// font-size: ${props => props.size ? props.size+'px' : '50px'};

export const TitleText = styled.text`
    font-family: BlenderPro-Thin;
    font-size: calc(26px + (52 - 26) * ((100vw - 300px) / (1600 - 300)));
    ${props => props.logo ? 'font-size: calc(28px + (40 - 28) * ((100vw - 770px) / (1600 - 770)))' : ''};
    letter-spacing: calc(2px + (10 - 2) * ((100vw - 300px) / (1600 - 300)));
    line-height: calc(26px + (60 - 26) * ((100vw - 300px) / (1600 - 300)));
    text-transform: uppercase;
    color: #ffffff;
    display: block;
    text-shadow: 2px 2px 5px #05070F;
`;

export const ParagraphText = styled.text`
    font-family: 'Montserrat', sans-serif;
    font-size: calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
    font-weight: 400;
    color: ${props => props.dark ? '#060812' : '#7B7B7F'};
`;
